const BREAKPOINTS_SIZES = {
  desktop: '1200px',
  tablet: '992px',
  mobile: '768px',
};

export const DEVICES = {
  desktop: `(min-width: ${BREAKPOINTS_SIZES.tablet})`,
};
